import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useRef } from 'react';
import { createContext } from '../utils/createContext';

var _createContext = createContext('AutoId'),
    _createContext2 = _slicedToArray(_createContext, 2),
    useAutoIdContext = _createContext2[0],
    Context = _createContext2[1];

export { Context, useAutoIdContext };

/**
 * A provider for use with the `useId` hook. It supplies a function that can
 * be called to increment and return a numeric ID.
 */
export default function AutoIdProvider(_ref) {
  var children = _ref.children,
      counter = _ref.counter;
  var defaultCounter = useRef(0);

  if (!counter) {
    counter = defaultCounter;
  }

  var getId = useCallback(() => ++counter.current, [counter]);
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: getId
  }, children);
}
AutoIdProvider.Context = Context;